import { render, staticRenderFns } from "./DepositRedesign.vue?vue&type=template&id=7cf33a43&scoped=true"
import script from "./DepositRedesign.vue?vue&type=script&lang=js"
export * from "./DepositRedesign.vue?vue&type=script&lang=js"
import style0 from "./DepositRedesign.vue?vue&type=style&index=0&id=7cf33a43&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cf33a43",
  null
  
)

export default component.exports